import {stateBase} from './index'
export default {
  memberFn(state, parameter) {
    if(parameter&&parameter.reset){
      state.member=JSON.parse(JSON.stringify(stateBase.member));
    }else{
      Object.assign(state.member, parameter);
    }
  },
  memberInfoFn(state, parameter) {
    if(parameter&&parameter.reset){
      state.memberInfo=JSON.parse(JSON.stringify(stateBase.memberInfo));
    }else{
      Object.assign(state.memberInfo, parameter);
    }
  },
  secretFn(state, parameter) {
    if(parameter&&parameter.reset){
      state.secret=JSON.parse(JSON.stringify(stateBase.secret));
    }else{
      Object.assign(state.secret, parameter);
    }
  },
  otherFn(state, parameter) {
    if(parameter&&parameter.reset){
      state.other=JSON.parse(JSON.stringify(stateBase.other));
    }else{
      Object.assign(state.other, parameter);
    }
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/my/mutations.js